import { createQueryKeyStore } from '@lukemorales/query-key-factory';

export const automationQueries = createQueryKeyStore({
  automations: {
    statuses: (districtId: number) => ({
      queryKey: [districtId],
    }),
    list: (roleId: number) => ({
      queryKey: [roleId],
    }),
  },
});
